import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ChangePasswordCard() {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("New passwords do not match.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated. Your session has been refreshed.");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : Array.isArray(d) ? d[0]?.msg : "Could not change password");
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="card-soft p-6" data-testid="change-password-card">
      <div className="flex items-center gap-2 mb-2"><KeyRound className="w-5 h-5 text-[#7C3AED]" /><h3 className="font-heading font-semibold text-lg text-[#1E1560]">Change password</h3></div>
      <p className="text-xs text-secondary mb-4">At least 10 characters with upper, lower, number and symbol.</p>
      <div className="space-y-2">
        <Input type="password" required placeholder="Current password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="pw-current-input" className="rounded-lg" />
        <Input type="password" required placeholder="New password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="pw-new-input" className="rounded-lg" />
        <Input type="password" required placeholder="Confirm new password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="pw-confirm-input" className="rounded-lg" />
      </div>
      <Button type="submit" disabled={busy} data-testid="pw-submit-btn" className="mt-4 rounded-full bg-[#2A1E9E] hover:bg-[#3A2DB8] text-white w-full">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
      </Button>
    </form>
  );
}
